import { isSku } from "@utils/general";

import { AlgoliaSearchQuery } from "@services/algolia/types/search.types";

const transformQueryForMultiSku = (
    searchQuery: AlgoliaSearchQuery,
): AlgoliaSearchQuery => {
    const query = searchQuery?.query?.toString();

    const splittedQuery = query?.split(" ");

    if (
        splittedQuery &&
        splittedQuery.length > 1 &&
        splittedQuery.every(q => isSku(q))
    ) {
        searchQuery = {
            ...searchQuery,
            query: undefined,
            filters: splittedQuery
                .map(q => `productIdentifiers:${q}`)
                .join(" OR "),
        };

        delete searchQuery?.query;
    }

    return searchQuery;
};

export default transformQueryForMultiSku;
